import { Alert, Button, Collapse, Form, message, Popconfirm, Row } from 'antd';
import countries from 'assets/json/countries.json';
import phoneMasks from 'assets/json/phoneMasks.json';
import { ActiveConsumer } from 'contexts/legacy/ActiveContext';
import { Bitrix24Consumer } from 'contexts/legacy/Bitrix24Context';
import { LanguageConsumer } from 'contexts/legacy/LanguageContext';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import { SystemConsumer } from 'contexts/legacy/SystemContext';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import powerzapLogo from 'assets/logos/powerzap-kory.svg';
import whatsappSupport from 'assets/logos/whatsapp-support.svg';
import { api } from 'services/api';
import { loadPlanType } from 'utils/subscription/loadPlanType';
import 'styles/form.css';
import './onboarding.css';
import PhaseBar from './PhaseBar';
import ChannelScreen from './screens/Channel/ChannelScreen';
import ConnectionChoiceScreen from './screens/ConnectionChoiceScreen';
import ConnectedScreen from './screens/ConnectedScreen';
import DoneScreen from './screens/DoneScreen';
import FirstMessageScreen from './screens/FirstMessageScreen';
import LeadCaptureScreen from './screens/LeadCaptureScreen';
import MetaConnectScreen from './screens/MetaConnectScreen';
import PhoneScreen from './screens/PhoneScreen';
import QrCodeScreen from './screens/QrCodeScreen';
import TokenScreen from './screens/TokenScreen';
import WebhookScreen from './screens/WebhookScreen';
import WelcomeScreen from './screens/WelcomeScreen';
import { needWebhook, SCREENS, useDeviceId, useNamespace } from './data';

const { Panel } = Collapse;
const ONBOARDING_STORAGE_KEY = 'powerzap_onboarding_state';
const DEFAULT_NICKNAME = 'Whatsapp Integration';

class StepProgress extends Component {
	constructor(props) {
		super(props);
		this.mounted = false;
		this.gaSent = false;
		this.metaFinished = false;
		// API do numero ja cadastrado neste onboarding (ver resetConnection).
		this.registeredApi = null;
		this.qrReadTimeoutID = 0;
		this.startSessionTimeoutID = 0;
		this.state = {
			screenIndex: 0,
			done: false,
			showDeviceId: false,
			showNamespace: false,
			channel: '',
			dados: {},
			country_value: { iso2: 'br', dialCode: '55', phone: '+55' },
			formNumber: {
				id: '',
				nickname: DEFAULT_NICKNAME,
				api: 'zapi',
				token: '',
				device_id: '',
				namespace: '',
				country_code: 'br',
				country_code_dial: '55',
				remove_cc: '0',
				number: '55',
				status: '1',
			},
			formSubmitted: false,
			openModal: false,
			countries,
			country: '',
			phoneMasks,
			selected_phone_mask: '',
			phoneNumber: '',
			enterprise_website: '',
			loading: false,
			showErrors: false,
			showQRCode: false,
			qrRead: false,
			numberDisconnected: false,
			showContainerMsg: false,
			isRegeneratingQr: false,
			qrError: '',
			qrcode: '',
			sessionStarted: false,
			selectedOption: '',
			countrySelected: '',
			isSubmitting: false,
		};

		this.onSubmit = this.onSubmit.bind(this);
		this.startContainer = this.startContainer.bind(this);
		this.startSession = this.startSession.bind(this);
		this.deleteSession = this.deleteSession.bind(this);
		this.updateQRCode = this.updateQRCode.bind(this);
		this.getSessionInfo = this.getSessionInfo.bind(this);
		this.qrReadTimeout = this.qrReadTimeout.bind(this);
		this.qrRead = false;
		this.updateQRCodeID = 0;
		this.getSessionInfoID = 0;
		this.startSessionID = 0;
	}

	async componentDidMount() {
		this.mounted = true;

		this.props.active.createCustomer(0).catch((e) => {
			if (e.msg) {
				message.error(e.msg);
			}
		});
		this.props.number.isWellcomeScreen = true;

		this.maybeSendGaEvent();
		this.restoreOnboardingState();
	}

	componentDidUpdate() {
		this.maybeSendGaEvent();
		this.persistOnboardingState();
	}

	componentWillUnmount() {
		this.mounted = false;
		clearInterval(this.updateQRCodeID);
		clearInterval(this.getSessionInfoID);
		clearInterval(this.startSessionID);
		clearTimeout(this.qrReadTimeoutID);
		clearTimeout(this.startSessionTimeoutID);
	}

	maybeSendGaEvent() {
		if (!this.gaSent && this.props.bitrix24.onbitrix) {
			this.gaSent = true;
			this.sendEvent();
		}
	}

	getOnboardingStorageKey = () => {
		if (typeof window === 'undefined') return null;

		try {
			if (!window.sessionStorage) return null;
			const domain = window.BX24?.getDomain?.();
			return domain ? `${ONBOARDING_STORAGE_KEY}:${domain}` : null;
		} catch (e) {
			return null;
		}
	};

	persistOnboardingState = () => {
		const key = this.getOnboardingStorageKey();
		if (!key) return;

		const {
			screenIndex,
			done,
			formNumber,
			formSubmitted,
			dados,
			channel,
			selectedOption,
			countrySelected,
			selected_phone_mask,
			phoneNumber,
			enterprise_website,
			country,
			country_value,
		} = this.state;

		try {
			window.sessionStorage.setItem(
				key,
				JSON.stringify({
					registeredApi: this.registeredApi,
					screenIndex,
					done,
					formNumber,
					formSubmitted,
					dados,
					channel,
					selectedOption,
					countrySelected,
					selected_phone_mask,
					phoneNumber,
					enterprise_website,
					country,
					country_value,
				}),
			);
		} catch (e) {
			// Session storage can be unavailable in restricted browser contexts.
		}
	};

	restoreOnboardingState = () => {
		const key = this.getOnboardingStorageKey();
		if (!key) return;

		try {
			const savedState = JSON.parse(window.sessionStorage.getItem(key) || 'null');
			if (!savedState || !savedState.formNumber) return;

			const api = savedState.formNumber.api || 'zapi';
			this.registeredApi = savedState.registeredApi || null;
			const sequence = SCREENS[api] || SCREENS.zapi;
			const savedScreenIndex = Number(savedState.screenIndex);
			const screenIndex = Math.min(
				Math.max(Number.isFinite(savedScreenIndex) ? savedScreenIndex : 0, 0),
				sequence.length - 1,
			);

			this.setState(
				(prev) => ({
					screenIndex,
					done: Boolean(savedState.done),
					formSubmitted: Boolean(savedState.formSubmitted),
					formNumber: { ...prev.formNumber, ...savedState.formNumber, api },
					dados: savedState.dados || {},
					channel: savedState.channel || '',
					selectedOption: savedState.selectedOption || '',
					countrySelected: savedState.countrySelected || '',
					selected_phone_mask: savedState.selected_phone_mask || '',
					phoneNumber: savedState.phoneNumber || '',
					enterprise_website: savedState.enterprise_website || '',
					country: savedState.country || '',
					country_value: savedState.country_value || prev.country_value,
				}),
				() => {
					if (this.currentScreen() === 'connect' && api === 'zapi') {
						this.getQRCode();
					}
				},
			);
		} catch (e) {
			// Ignore invalid or unavailable persisted onboarding state.
		}
	};

	clearOnboardingState = () => {
		const key = this.getOnboardingStorageKey();
		if (!key) return;

		try {
			window.sessionStorage.removeItem(key);
		} catch (e) {
			// Session storage can be unavailable in restricted browser contexts.
		}
	};

	startContainer = async (formNumber) => {
		const { number } = this.props;
		const { language } = this.props.language;
		let result;
		await number
			.startContainer(formNumber)
			.then((res) => {
				if (!this.mounted) return;
				result = res;

				if (res.status) {
					this.setState((prev) => ({
						qrError: '',
						formNumber: {
							...prev.formNumber,
							token: res.token,
							device_id: res.device_id,
							namespace: res.namespace,
						},
					}));

					this.startSessionID = setInterval(this.getQRCode, 60000);

					this.startSessionTimeoutID = setTimeout(() => {
						clearInterval(this.startSessionID);
						if (this.mounted) {
							this.setState({ showContainerMsg: false, qrError: 'Failed to start Container' });
							message.error('Failed to start Container');
						}
					}, 1200000);
				} else {
					message.error(res?.message || language.start_session_failed);
				}
			})
			.catch((e) => {
				result = { status: false, message: language.start_session_failed };
				message.error(language.start_session_failed + ' ' + e);
			});

		return result;
	};

	startSession = async (formNumber) => {
		const { number } = this.props;
		const { language } = this.props.language;
		let result;
		let sessionFormNumber = formNumber;

		if (formNumber.api !== 'zapi') {
			return;
		}

		if (!formNumber.token) {
			result = await this.startContainer(formNumber);
			if (!result || !result.status) {
				return result;
			}

			sessionFormNumber = {
				...formNumber,
				token: result.token,
				device_id: result.device_id || formNumber.device_id,
				namespace: result.namespace || formNumber.namespace,
			};
		}

		await number
			.startSession(sessionFormNumber)
			.then((res) => {
				if (!this.mounted) return;
				result = res;
				if (res.status) {
					this.setState(
						(prev) => ({
							sessionStarted: true,
							formNumber: {
								...prev.formNumber,
								token: res.token || sessionFormNumber.token,
							},
						}),
						() => clearInterval(this.startSessionID),
					);
				}
			})
			.catch((e) => {
				result = { status: false, message: language.start_session_failed };
				message.error(language.start_session_failed + ' ' + e);
			});

		return result;
	};

	// O ID do interval e a guarda de "polling ativo" do getQRCode: limpar sem zerar fazia o
	// "Gerar QR Code novamente" iniciar a sessao e nunca mais buscar o QR.
	// Trocar de conexao depois de cadastrar um numero: sem isto o cadastro da nova reaproveita o id
	// e o apelido da anterior - edita o registro dela ou cai em "nickname_already_registered".
	// O numero ja cadastrado continua no banco; nada e apagado.
	resetConnection(callback) {
		this.registeredApi = null;
		this.qrRead = false;
		this.stopQrPolling();
		this.setState(
			(prev) => ({
				formNumber: {
					...prev.formNumber,
					id: '',
					nickname: DEFAULT_NICKNAME,
					token: '',
					device_id: '',
					namespace: '',
					waba_account_id: '',
					picture_url: '',
					number: prev.formNumber.country_code_dial,
				},
				dados: {},
				qrRead: false,
				sessionStarted: false,
				qrcode: '',
				profileInfo: {},
				numberDisconnected: false,
			}),
			callback,
		);
	}

	stopQrPolling() {
		clearInterval(this.updateQRCodeID);
		clearInterval(this.getSessionInfoID);
		this.updateQRCodeID = 0;
		this.getSessionInfoID = 0;
	}

	deleteSession = async () => {
		const { number } = this.props;
		const { language } = this.props.language;

		clearInterval(this.startSessionID);
		this.stopQrPolling();

		let result;
		try {
			result = await number.deleteSession(this.state.formNumber);
		} catch (e) {
			message.error(language.start_session_failed + ' ' + e);
			result = { status: false, error: e };
		}

		this.qrRead = false;
		if (this.mounted) {
			this.setState({
				sessionStarted: false,
				loadingQRCode: false,
				qrRead: false,
				profileInfo: {},
				qrError: '',
				qrcode: '',
			});
		}

		return result;
	};

	updateQRCode = async () => {
		const { number } = this.props;
		if (!this.qrRead) {
			await number.getQRCode(this.state.formNumber).then((res) => {
				if (!this.mounted) return;
				if (res.status) {
					this.setState({ qrcode: res.qrCode }, function () {
						this.setState({ numberDisconnected: false });
					});
				}
			});
		}
	};

	reloadQRCode = async () => {
		await this.updateQRCode();
		if (!this.mounted) return;
		clearInterval(this.updateQRCodeID);
		clearInterval(this.getSessionInfoID);
		this.updateQRCodeID = setInterval(this.updateQRCode, 18000);
		this.getSessionInfoID = setInterval(this.getSessionInfo, 5000);
		const self = this;
		clearTimeout(this.qrReadTimeoutID);
		this.qrReadTimeoutID = setTimeout(function () {
			self.qrReadTimeout();
		}, 240000);
	};

	getSessionInfo = async (formNumber = this.state.formNumber) => {
		if (!this.qrRead) {
			await this.props.number.getSessionInfo(formNumber).then((res) => {
				if (res.status && res.info) {
					this.qrRead = true;
					clearInterval(this.updateQRCodeID);
					if (!this.mounted) return;
					this.setState(
						(prev) =>
							prev.qrRead
								? null
								: {
										profileInfo: res.info,
										qrRead: true,
										formNumber: {
											...prev.formNumber,
											token: formNumber.token || prev.formNumber.token,
											number: res.info.clientNumber,
										},
								  },
						() => clearInterval(this.getSessionInfoID),
					);
				}
			});
		}
	};

	qrReadTimeout = async () => {
		if (!this.mounted) return;
		if (!this.qrRead) {
			this.stopQrPolling();
			this.setState({ numberDisconnected: true }, function () {
				if (this.state.sessionStarted) {
					this.deleteSession();
				}
			});
		}
	};

	getQRCode = async () => {
		const { number } = this.props;
		const { language } = this.props.language;
		const formNumber = this.state.formNumber;

		if (formNumber.api !== 'zapi') {
			return;
		}

		if (!this.state.sessionStarted) {
			this.setState({ showContainerMsg: true, qrError: '' });

			const result = await this.startSession(formNumber);
			if (!this.mounted) return;

			if (!result?.status) {
				const errorMessage = result?.message || language.start_session_failed;
				this.setState({ showContainerMsg: false, qrError: errorMessage });
				return;
			}

			await new Promise((resolve) => {
				this.setState({ showContainerMsg: false, qrError: '' }, resolve);
			});
			if (this.state.showContainerMsg === false) {
				await window.BX24.callMethod('im.notify', {
					to: number.user.ID,
					message: language.session_start_alert,
				});
			}

			if (result.connected) {
				const sessionFormNumber = {
					...this.state.formNumber,
					token: result.token || formNumber.token,
				};
				await this.getSessionInfo(sessionFormNumber);
				if (this.qrRead) return;
			}
		}

		if (!this.updateQRCodeID) {
			await this.updateQRCode();
			if (!this.mounted) return;
			this.updateQRCodeID = setInterval(this.updateQRCode, 18000);
			this.getSessionInfoID = setInterval(this.getSessionInfo, 5000);
			const self = this;
			clearTimeout(this.qrReadTimeoutID);
			this.qrReadTimeoutID = setTimeout(function () {
				self.qrReadTimeout();
			}, 240000);
		}
	};

	onSelectCountry = (value) => {
		const selectedCountry = this.state.countries.find((country) => country.code === value);

		if (selectedCountry) {
			this.setState({
				countrySelected: selectedCountry.name,
				selected_phone_mask: this.state.phoneMasks[value],
				phoneNumber: '',
				country: `${selectedCountry.name} (${selectedCountry.code})`,
			});
		}
	};

	goToApp = () => {
		this.clearOnboardingState();
		this.props.active.createCustomer('api_whatsapp_finalizou_instalacao').catch((e) => {
			if (e.msg) {
				message.error(e.msg);
			}
		});
		this.props.number.isWellcomeScreen = false;
		window.location.href = process.env.PUBLIC_URL + '/';
	};

	skipStep = async () => {
		this.clearOnboardingState();
		const self = this;
		await self.props.system
			.setTour()
			.then(async () => {
				await self.props.system
					.addSubscription()
					.then(async () => {
						self.goToApp();
					})
					.catch((e) => {
						if (e.msg) {
							message.error(e.msg);
						} else {
							message.error(self.props.language.add_subscription_error);
						}
					});
			})
			.catch((e) => {
				if (e.msg) {
					message.error(e.msg);
				} else {
					message.error(self.props.language.add_subscription_error);
				}
			});
	};

	checkKnowYouBetterStatus = () => {
		this.setState({ openModal: true });
	};

	async onSubmit(event) {
		event.preventDefault();

		this.props.form.validateFields(async (err, _values) => {
			if (!err) {
				this.setState({
					isSubmitting: true,
				});

				const auth = window.BX24 ? window.BX24.getAuth() : { domain: 'solinka.bitrix24.com' };
				const domain = auth.domain;

				const myForm = document.getElementById('_form_72_');
				const formData = new FormData(myForm);

				const b24Domain = window.BX24.getDomain();
				formData.append('domain', b24Domain);

				formData.append('objective', this.state.selectedOption);
				formData.append('country', this.state.countrySelected);

				const form = {
					fullName: formData.get('fullname'),
					email: formData.get('email'),
					phoneNumber: formData.get('field[16]'),
					country: this.state.country,
					enterprise_website: this.state.enterprise_website,
				};

				const request = {
					action: 'saveForm',
					form,
					domain,
				};

				await api.post('saveForm', request);
				if (!this.mounted) return;

				try {
					const { data } = await api.post('addLeadInRdStation', formData);
					if (!this.mounted) return;

					if (data === 'lead already registered') {
						this.setState({
							formSubmitted: true,
							isSubmitting: false,
						});
						return;
					}

					this.setState({ formSubmitted: true });
				} catch (error) {
					if (!this.mounted) return;
					console.log(
						'StepProgress::onSubmit - erro ao submeter o formulário de captura de lead: ',
						{
							Exception: error,
						},
					);

					this.setState({ isSubmitting: false });
				}
			} else {
				return;
			}
		});
	}

	async doRegistration() {
		const { formNumber } = this.state;
		const { getListOfNumbers, getListCampaigns, getConnectedChannels } = this.props.number;
		const { language } = this.props.language;

		await this.props.system
			.setTour()
			.then(async () => {
				await this.props.system
					.addSubscription()
					.then(async () => {
						await this.props.number
							.addEditNumber(formNumber)
							.then((response) => {
								if (!this.mounted) return;
								this.registeredApi = this.state.formNumber.api;
								this.setState({ dados: response.dados });

								if (!this.state.formNumber.id) {
									const newFormNumber = {
										formNumber: {
											...this.state.formNumber,
											id: response.dados,
										},
									};
									this.setState(newFormNumber);
								}
								message.success(language.add_number_success);
								getListOfNumbers();
								getListCampaigns();
								getConnectedChannels();
								this.advance();
							})
							.catch((e) => {
								if (!this.mounted) return;
								console.log('StepProgress::doRegistration', { Exception: e });
								if (e.msg) {
									message.error(e.msg);
								} else {
									message.error(language.add_number_error);
								}
							});
					})
					.catch((e) => {
						if (!this.mounted) return;
						if (e.msg) {
							message.error(e.msg);
						} else {
							message.error(language.add_subscription_error);
						}
					});
			})
			.catch((e) => {
				if (!this.mounted) return;
				if (e.msg) {
					message.error(e.msg);
				} else {
					message.error(language.add_subscription_error);
				}
			});
	}

	onChange = (value) => {
		this.setState({ country_value: { ...value, phone: '+' + value.dialCode } });
		this.setState({
			formNumber: {
				...this.state.formNumber,
				country_code: value.iso2,
				country_code_dial: value.dialCode,
				number: value.dialCode,
			},
		});
	};

	prev() {
		this.setState((prev) => {
			if (prev.done) {
				return { done: false };
			}
			return { screenIndex: Math.max(prev.screenIndex - 1, 0) };
		});
	}

	currentSeq() {
		return SCREENS[this.state.formNumber.api] || SCREENS.zapi;
	}

	currentScreen() {
		const seq = this.currentSeq();
		const entry = seq[this.state.screenIndex] || seq[0];
		return entry[0];
	}

	currentPhase() {
		const seq = this.currentSeq();
		const entry = seq[this.state.screenIndex] || seq[0];
		return entry[1];
	}

	advance() {
		this.setState((prev) => {
			const seq = SCREENS[prev.formNumber.api] || SCREENS.zapi;
			if (prev.screenIndex >= seq.length - 1) {
				return { done: true };
			}
			return { screenIndex: prev.screenIndex + 1 };
		});
	}

	setApi(api) {
		this.setState((prev) => {
			const prevSeq = SCREENS[prev.formNumber.api] || SCREENS.zapi;
			const entry = prevSeq[prev.screenIndex];
			const name = entry ? entry[0] : null;
			const nextSeq = SCREENS[api] || SCREENS.zapi;
			const idx = nextSeq.findIndex((s) => s[0] === name);

			return {
				formNumber: { ...prev.formNumber, api },
				screenIndex: idx === -1 ? 0 : idx,
				showDeviceId: useDeviceId.indexOf(api) > -1,
				showNamespace: useNamespace.indexOf(api) > -1,
			};
		});
	}

	next() {
		const api = this.state.formNumber.api;
		const screen = this.currentScreen();

		const legacyTrack = { welcome: 0, channel: 4 }[screen];
		if (legacyTrack !== undefined) {
			this.props.active.createCustomer(legacyTrack).catch((e) => {
				if (e.msg) {
					message.error(e.msg);
				}
			});
		}

		if (screen === 'welcome') {
			this.setState((prev) => ({
				formNumber: { ...prev.formNumber, token: '' },
			}));
			this.advance();
			return;
		}

		if (screen === 'choice') {
			// Cada saida da escolha e uma tentativa nova: libera a guarda de cadastro da Meta.
			this.metaFinished = false;
			const start = () => {
				if (this.state.formNumber.api === 'zapi') {
					this.getQRCode();
				}
			};
			if (this.registeredApi && this.registeredApi !== api) {
				// getQRCode le o token do estado: so depois do reset aplicado.
				this.resetConnection(start);
			} else {
				start();
			}
			this.advance();
			return;
		}

		if (screen === 'connect' || screen === 'phone') {
			this.doRegistration();
			return;
		}

		if (screen === 'channel') {
			if (needWebhook.indexOf(api) > -1) {
				this.advance();
			} else {
				this.doLinkChannel();
			}
			return;
		}

		this.advance();
	}

	async doLinkChannel() {
		const { language } = this.props.language;
		const id = this.state.dados;
		const { channel } = this.state;

		// O backend grava qualquer channel_id (vazio vira null) e responde sucesso.
		if (!this.hasValidChannel()) {
			message.error(language.link_channel_error);
			return;
		}

		await this.props.bitrix24
			.linkChannel(id, channel)
			.then(() => {
				if (!this.mounted) return;
				message.success(language.link_channel_success);
				this.advance();
			})
			.catch((e) => {
				if (!this.mounted) return;
				console.log('StepProgress::doLinkChannel', { Exception: e });
				if (e.msg) {
					message.error(e.msg);
				} else {
					message.error(language.link_channel_error);
				}
			});
	}

	async sendEvent() {
		const { sendEventGA } = this.props.active;
		await sendEventGA('welcome_access');
	}

	handleChange(e) {
		const target = e.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		this.setState({
			[name]: value,
		});
	}

	handleSelectChange = (value) => {
		this.setState({ selectedOption: value });
	};

	handleReloadQr = async () => {
		if (this.state.isRegeneratingQr) return;

		clearTimeout(this.qrReadTimeoutID);
		this.setState({
			isRegeneratingQr: true,
			showContainerMsg: true,
			qrError: '',
			qrcode: '',
			numberDisconnected: false,
		});

		await this.deleteSession();
		if (!this.mounted) return;

		this.setState(
			(prev) => ({
				formNumber: {
					...prev.formNumber,
					token: '',
					device_id: '',
					namespace: '',
				},
				numberDisconnected: false,
				showContainerMsg: true,
			}),
			() =>
				this.getQRCode().finally(() => {
					if (this.mounted) {
						this.setState({ isRegeneratingQr: false });
					}
				}),
		);
	};

	handleFieldChange = (field, value) => {
		this.setState((prev) => ({
			formNumber: { ...prev.formNumber, [field]: value },
		}));
	};

	handleSelectChannel = (value) => {
		this.setState({ channel: value });
	};

	// Canal selecionado precisa estar na lista atual: o estado restaurado pode trazer um canal apagado.
	hasValidChannel() {
		return (this.props.bitrix24.channels || []).some(
			(ch) => String(ch.ID) === String(this.state.channel) && ch.ACTIVE !== 'N',
		);
	}

	handleReloadChannels = () => {
		this.props.bitrix24.listChannelsOnBitrix(this.props.bitrix24.infos);
	};

	handleSelectApi = (api) => {
		this.setApi(api);
	};

	handleFirstMessageSent = (dialogId) => {
		this.setState({ chatDialogId: dialogId || null });
		this.advance();
	};

	// "Ir para Bate-papo" abre a conversa da mensagem de teste; o resto e o goToApp de sempre.
	handleGoToChat = () => {
		if (this.state.chatDialogId) {
			window.BX24.im.openMessenger('chat' + this.state.chatDialogId);
		}
		this.goToApp();
	};

	handleConfigureChannels = () => {
		window.open(`https://${window.BX24.getDomain()}/contact_center/`, '_blank', 'noopener');
	};

	// Resolve `false` quando o cadastro falhou: a tela da Meta mostra "Tentar novamente".
	handleMetaFinish = (updatedFormNumber) =>
		new Promise((resolve) => {
			if (!this.mounted || this.metaFinished) {
				resolve(true);
				return;
			}
			this.metaFinished = true;
			this.setState({ formNumber: updatedFormNumber }, async () => {
				const indexBefore = this.state.screenIndex;
				await this.doRegistration();
				// doRegistration engole os erros e so avanca o cursor no caminho de sucesso.
				// Cursor parado significa falha: libera a guarda para o usuario tentar de novo.
				const failed = this.mounted && this.state.screenIndex === indexBefore;
				if (failed) {
					this.metaFinished = false;
				}
				resolve(!failed);
			});
		});

	buildAgreements() {
		const { language } = this.props.language;
		// Ordem do grid no Figma: Envie | Distribua na primeira linha, Receba | Automatize na segunda.
		return [
			{ title: language.agree0, description: language.agree_desc0 },
			{ title: language.agree2, description: language.agree_desc2 },
			{ title: language.agree1, description: language.agree_desc1 },
			{ title: language.agree3, description: language.agree_desc3 },
		];
	}

	buildObjectiveOptions() {
		const { language } = this.props.language;
		return [
			{ value: 'Aumentar as vendas', label: language.option_increase },
			{
				value: 'Aumentar a eficiência do atendimento ao cliente',
				label: language.option_improve,
			},
			{ value: 'Automatizar a comunicação', label: language.option_automate },
			{
				value: 'Realizar campanhas de marketing via WhatsApp',
				label: language.option_whatsapp,
			},
			{
				value: 'Extrair informações das interações com clientes e leads',
				label: language.option_extract,
			},
			{
				value: 'Centralizar a comunicação em uma única plataforma',
				label: language.option_centralize,
			},
			{ value: 'Outros', label: language.option_other },
		];
	}

	handleEmailChange = (e) => {
		this.setState({ email: e.target.value });
	};

	handleWebsiteChange = (e) => {
		this.setState({ enterprise_website: e.target.value });
	};

	handleSelectObjective = (value) => {
		this.handleSelectChange(value);
	};

	shouldCaptureLead() {
		return !this.state.formSubmitted && process.env.REACT_APP_ENABLE_LEAD_FORM === 'true';
	}

	renderScreen() {
		if (this.state.done) {
			return (
				<DoneScreen
					onFinish={this.handleGoToChat}
					onConfigureChannels={this.handleConfigureChannels}
				/>
			);
		}

		switch (this.currentScreen()) {
			case 'welcome':
				return <WelcomeScreen agreements={this.buildAgreements()} />;
			case 'choice':
				return (
					<ConnectionChoiceScreen
						api={this.state.formNumber.api}
						planType={loadPlanType(
							this.props.system.loadingSubscription,
							this.props.system.subscription,
						)}
						onSelectApi={this.handleSelectApi}
					/>
				);
			case 'connect':
				return this.state.qrRead ? (
					<ConnectedScreen
						avatarUrl={this.state.profileInfo?.profilePicUrl}
						phone={this.state.formNumber.number}
						isRegeneratingQr={this.state.isRegeneratingQr}
						onReloadQr={this.handleReloadQr}
					/>
				) : (
					<QrCodeScreen
						qrcode={this.state.qrcode}
						numberDisconnected={this.state.numberDisconnected}
						showContainerMsg={this.state.showContainerMsg}
						isRegeneratingQr={this.state.isRegeneratingQr}
						qrError={this.state.qrError}
						onReloadQr={this.handleReloadQr}
					/>
				);
			case 'metaConnect':
				return (
					<MetaConnectScreen formNumber={this.state.formNumber} onFinish={this.handleMetaFinish} />
				);
			case 'connected':
				return (
					<ConnectedScreen
						avatarUrl={this.state.formNumber.picture_url}
						phone={this.state.formNumber.number}
					/>
				);
			case 'token':
				return (
					<TokenScreen
						form={this.props.form}
						language={this.props.language.language}
						formNumber={this.state.formNumber}
						showDeviceId={this.state.showDeviceId}
						showNamespace={this.state.showNamespace}
						onFieldChange={this.handleFieldChange}
					/>
				);
			case 'phone':
				return (
					<PhoneScreen
						form={this.props.form}
						formNumber={this.state.formNumber}
						countryValue={this.state.country_value}
						onCountryChange={this.onChange}
						onFieldChange={this.handleFieldChange}
					/>
				);
			case 'channel':
				return (
					<ChannelScreen
						channels={this.props.bitrix24.channels}
						loadingChannels={this.props.bitrix24.loadingChannels}
						channelsError={this.props.bitrix24.channelsError}
						onReloadChannels={this.handleReloadChannels}
						onConfigureChannels={this.handleConfigureChannels}
						channel={this.state.channel}
						onSelectChannel={this.handleSelectChannel}
					/>
				);
			case 'webhook':
				return <WebhookScreen />;
			case 'firstMessage':
				return (
					<FirstMessageScreen
						formNumber={this.state.formNumber}
						number={this.props.number}
						active={this.props.active}
						language={this.props.language.language}
						onPrevious={() => this.prev()}
						onComplete={this.handleFirstMessageSent}
					/>
				);
			default:
				return null;
		}
	}

	render() {
		return (
			<>
				<div className="onboarding-page">
					<Row>
						{this.props.system.subscription.days_left !== 0 && (
							<Alert
								message={
									<FormattedMessage
										id="time_left"
										values={{
											days: this.props.system.subscription.days_left,
										}}
									/>
								}
								type="warning"
								showIcon
								style={{ float: 'right' }}
							/>
						)}
					</Row>

					{this.props.bitrix24.installationErrors?.length > 0 && (
						<Row style={{ paddingTop: '10px', paddingBottom: '10px' }}>
							<Collapse>
								<Panel
									header={<strong>{this.props.language.language.installation_errors_found}</strong>}
									style={
										this.props.bitrix24.installationErrors.filter(
											(e) => e.scope === 'handler_imconnector',
										).length > 0
											? {
													backgroundColor: 'rgba(254, 13, 33, 0.4)',
													border: '1px solid #fe0d21',
											  }
											: {
													backgroundColor: 'rgba(255, 174, 13, 0.4)',
													border: '1px solid #FFAE0D',
											  }
									}
									key={1}
								>
									<Collapse>
										{this.props.bitrix24.installationErrors.map((item, index) => {
											return (
												<Panel
													header={
														<strong>
															{this.props.language.language[item.scope]}{' '}
															{item.additional_scope ?? ''}:
														</strong>
													}
													style={
														item.scope === 'handler_imconnector'
															? {
																	backgroundColor: 'rgba(254, 13, 33, 0.4)',
																	border: '1px solid #fe0d21',
															  }
															: {
																	backgroundColor: 'rgba(255, 174, 13, 0.4)',
																	border: '1px solid #FFAE0D',
															  }
													}
													key={index}
												>
													<p>{this.props.language.language[item.scope + '_message']}</p>
													<p>
														<strong>{this.props.language.language.error_found}:</strong>
														<br />
														{item.error}
													</p>
												</Panel>
											);
										})}
									</Collapse>
								</Panel>
							</Collapse>
						</Row>
					)}
					{this.shouldCaptureLead() ? (
						<LeadCaptureScreen
							form={this.props.form}
							language={this.props.language.language}
							options={this.buildObjectiveOptions()}
							countries={this.state.countries}
							isSubmitting={this.state.isSubmitting}
							onSubmit={this.onSubmit}
							onEmailChange={this.handleEmailChange}
							onWebsiteChange={this.handleWebsiteChange}
							onSelectCountry={this.onSelectCountry}
							onSelectObjective={this.handleSelectObjective}
						/>
					) : (
						<div className="onboarding-flow">
							{this.state.done ? (
								<div className="onboarding-logo">
									<img src={powerzapLogo} alt="PowerZap" />
								</div>
							) : (
								<PhaseBar current={this.currentPhase()} language={this.props.language.language} />
							)}
							<div
								className={`onboarding-content-card ${
									this.currentScreen() === 'firstMessage'
										? 'onboarding-content-card-first-message'
										: ''
								}`}
							>
								<div className="onboarding-content-inner">{this.renderScreen()}</div>
								{this.currentScreen() !== 'firstMessage' && (
									<div className="onboarding-actions">
										{this.state.screenIndex === 0 && !this.state.done && (
											<Popconfirm
												title={this.props.language.language.confirm_skip}
												visible={this.state.openModal}
												onConfirm={this.skipStep}
												onCancel={() => this.setState({ openModal: false })}
												okText={this.props.language.language.yes}
												cancelText={this.props.language.language.not}
												placement="topRight"
											>
												<Button
													size="large"
													className="onboarding-skip"
													loading={
														this.props.system.loadingConfirmSteps ||
														this.props.number.loadingAddNumber ||
														this.state.loading
													}
													onClick={this.checkKnowYouBetterStatus}
													disabled={this.state.loading}
												>
													<FormattedMessage id="skip" />
												</Button>
											</Popconfirm>
										)}
										{this.state.screenIndex > 0 && !this.state.done && (
											<Button
												size="large"
												className="onboarding-previous"
												onClick={() => this.prev()}
												disabled={
													this.currentScreen() === 'channel' && this.state.formNumber.api === 'zapi'
												}
											>
												<FormattedMessage id="previous" />
											</Button>
										)}
										{!this.state.done && (
											<Button
												size="large"
												type="primary"
												className="onboarding-next"
												loading={
													this.props.system.loadingConfirmSteps ||
													this.props.number.loadingAddNumber
												}
												onClick={() => this.next()}
												disabled={
													(this.currentScreen() === 'connect' &&
														!this.state.qrRead &&
														this.state.formNumber.api === 'zapi') ||
													this.currentScreen() === 'metaConnect' ||
													(this.currentScreen() === 'channel' && !this.hasValidChannel()) ||
													!this.state.formNumber.number
												}
											>
												<FormattedMessage id="continue_configuration" />
											</Button>
										)}
									</div>
								)}
							</div>
						</div>
					)}
					<a
						className="onboarding-support"
						href="https://atendimento.br24.io/"
						target="_blank"
						rel="noopener noreferrer"
						aria-label={this.props.language.language.support || 'Falar com o suporte'}
					>
						<img src={whatsappSupport} alt="" />
					</a>
				</div>
				{this.state.openModal ? (
					<div
						onClick={() => this.setState({ openModal: false })}
						style={{
							position: 'fixed',
							zIndex: '100',
							left: '0',
							top: '0',
							width: '100%',
							height: '100%',
							overflow: 'auto',

							backgroundColor: 'rgba(0,0,0,0.4)',
						}}
					/>
				) : null}
			</>
		);
	}
}

const WrappedStepsForm = Form.create({ name: 'steps_form' })(StepProgress);

export default Bitrix24Consumer(
	ActiveConsumer(SystemConsumer(NumberConsumer(LanguageConsumer(WrappedStepsForm)))),
);
